import * as React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useQueryClient } from "@tanstack/react-query";
import { Button } from "components/bootstrap";
import { ConfirmDialog, Icon } from "components/common";
import useStreamOutputRuleMutation from "components/streams/hooks/useStreamOutputRuleMutation";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
const FilterDeleteButton = ({ streamId, filterOutputRule }) => {
  const { t } = useTranslation("streams");
  const [showDialog, setShowDialog] = useState(false);
  const { removeStreamOutputRule } = useStreamOutputRuleMutation();
  const queryClient = useQueryClient();
  const sendTelemetry = useSendTelemetry();
  const onConfirmDelete = async () => {
    await removeStreamOutputRule({ streamId, filterId: filterOutputRule.id }).then(() => {
      queryClient.invalidateQueries({
        queryKey: ["streams"]
      });
    });
    setShowDialog(false);
  };
  const onDelete = () => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.STREAMS.STREAM_ITEM_DATA_ROUTING_FILTER_DELETE_OPENED, {
      app_pathname: "streams"
    });
    setShowDialog(true);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Button, { bsStyle: "danger", bsSize: "xsmall", onClick: onDelete, title: t("output_filter.delete_tooltip") }, /* @__PURE__ */ React.createElement(Icon, { name: "delete", type: "regular" })), showDialog && /* @__PURE__ */ React.createElement(
    ConfirmDialog,
    {
      title: t("output_filter.delete_title"),
      show: true,
      onConfirm: onConfirmDelete,
      onCancel: () => setShowDialog(false)
    },
    t("output_filter.delete_confirm", { title: filterOutputRule.title })
  ));
};
export default FilterDeleteButton;
